import AssistChip from 'components/Luxkit/Chips/AssistChip'
import DropdownChevron from 'components/Luxkit/Dropdown/DropdownChevron'
import DropdownList from 'components/Luxkit/Dropdown/List/DropdownList'
import RadioInput from 'components/Luxkit/Radio/RadioInput'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Group from 'components/utils/Group'
import { tourSortByTypes } from 'constants/offerListFilters'
import useQueryParams from 'hooks/useQueryParams'
import useToggle from 'hooks/useToggle'
import { pluralizeToString } from 'lib/string/pluralize'
import { rem } from 'polished'
import React, { useMemo, useRef } from 'react'
import styled from 'styled-components'

const RadioGroup = styled(Group)`
  padding-inline: ${rem(16)};
`

interface Props {
  fetching?: boolean | undefined,
  totalNumberOfOffers: number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function TourSearchSortHeader(props: Props) {
  const { fetching, totalNumberOfOffers, onChange } = props
  const [open, toggleSort, _, closeSort] = useToggle()

  const queryParams = useQueryParams()
  const triggerRef = useRef<HTMLButtonElement>(null)
  const sortParam = useMemo(() => queryParams.get('sortBy'), [queryParams])
  const selectedOption = useMemo(() =>
    tourSortByTypes.find(o => o.value === sortParam) ?? tourSortByTypes[0]
  , [sortParam])

  const onSortChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e)
    }
    closeSort()
  }

  const shouldShow = !fetching && totalNumberOfOffers > 0

  if (!shouldShow) {
    return null
  }

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="center" gap={8}>
      <BodyText variant="large">
        Showing {pluralizeToString('tour', totalNumberOfOffers)}
      </BodyText>
      <AssistChip
        variant="filled"
        size="medium"
        onClick={toggleSort}
        endIcon={<DropdownChevron open={open}/>}
        ref={triggerRef}
      >
        Sort: {selectedOption?.label}
      </AssistChip>
      <DropdownList
        size="S"
        open={open}
        onClose={closeSort}
        anchorRef={triggerRef}
        triggerRef={triggerRef}
        data-testid="sort-options-dropdown"
      >
        <RadioGroup direction="vertical" gap={16}>
          {tourSortByTypes.map(option => <RadioInput
            key={option.value}
            checked={selectedOption?.value === option.value}
            onChange={onSortChange}
            name="sort"
            value={option.value}
          >
            {option.label}
          </RadioInput>)}
        </RadioGroup>
      </DropdownList>
    </Group>
  )
}

export default TourSearchSortHeader
